import axios from "../../js/project-axios.js"

const stock = () => {
    return axios.get("/asset/report/stock");
};

export default {
    stock
};